import { render, staticRenderFns } from "./invoice-5.vue?vue&type=template&id=e1506080&"
import script from "./invoice-5.vue?vue&type=script&lang=js&"
export * from "./invoice-5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports